import { fetchUser } from '$lib/features/auth/api/auth.js';

export const ssr = false;

export async function load({ fetch }) {
	const user = await fetchUser(fetch);
	return { user };
}
